/* eslint-disable react-refresh/only-export-components */
import { ReactNode, useCallback } from 'react';
import { SessionManagerProvider } from './auth/SessionManager';
import { AnonymousClaimer } from './auth/effects';

export function AuthProvider({
  children,
  deferSessionDiscovery = false,
}: {
  children: ReactNode;
  deferSessionDiscovery?: boolean;
}) {
  const handlePasswordRecovery = useCallback(() => {
    if (typeof window !== 'undefined') {
      if (
        window.location.pathname === '/auth/confirm' ||
        window.location.pathname === '/auth/reset-password'
      ) {
        return;
      }
      window.location.assign('/auth/reset-password');
    }
  }, []);

  return (
    <SessionManagerProvider
      onPasswordRecovery={handlePasswordRecovery}
      deferSessionDiscovery={deferSessionDiscovery}
    >
      <AnonymousClaimer />
      {children}
    </SessionManagerProvider>
  );
}

// Re-exports for convenience
export { useSession } from './auth/SessionManager';
export type { User, SessionState } from './auth/types';
export {
  logOut,
  logInWithRedirect,
  logInWithEmail,
  signUpWithEmail,
  resendVerificationEmail,
  sendMagicLink,
  verifyEmailCode,
  requestPasswordReset,
  updatePassword,
} from './auth/actions';
export {
  settleCurrentAnonymousIdentity,
  settleEmbeddedAnonymousIdentity,
} from './auth/anonymousClaim';
export {
  confirmEmailAction,
  finishAuthCallback,
  parseAuthEmailAction,
} from './auth/internal/completion';
export type { AuthCallbackResult, AuthEmailAction } from './auth/internal/completion';
